export function paginate(totalRecords, pageSize, currentPage, totalPages) {
    const $paginator = $('[data-paginator-wrapper]');
    const $paginationSlot = $paginator.find('[data-pagination-slot]');
    const $prev = $paginationSlot.siblings('[data-page="prev"]');
    const $next = $paginationSlot.siblings('[data-page="next"]');
    
    let pages;
    let paginationButtons = [];
    let nCurrentPage;
    
    if (totalPages) {
        pages = totalPages;
    } else {
        pages = Math.ceil(totalRecords / pageSize);
    }
    
    if (currentPage < 1) {
        nCurrentPage = 1;
    } else if (currentPage > pages) {
        nCurrentPage = pages;
    } else {
        nCurrentPage = currentPage;
    }

    if (nCurrentPage === 1) {
        $prev.prop('disabled', true);
        $prev.toggleClass('disabled', true);
    } else {
        $prev.removeAttr('disabled');
        $prev.toggleClass('disabled', false);
    }

    if (nCurrentPage === pages) {
        $next.prop('disabled', true);
        $next.toggleClass('disabled', true);
    } else {
        $next.removeAttr('disabled');
        $next.toggleClass('disabled', false);
    }

    if (pages > 6) {
        let pageCounter = nCurrentPage + 5;
        if (pageCounter >= pages) {
            pageCounter = nCurrentPage + ((nCurrentPage - pages) * -1);
        }
        for (let i = nCurrentPage + 5 > pages ? nCurrentPage - (5 - (pages - nCurrentPage)) : nCurrentPage; i < pageCounter; i++) {
            paginationButtons.push(
                $(`<button data-page="${i}" type="button" role="button" class="${nCurrentPage === i ? 'tabulator-page active disabled' : 'tabulator-page'}" ${i === nCurrentPage ? 'disabled' : ''}>
                        ${i}
                    </button>
                    `)[0]);
        }
        if (nCurrentPage + 5 < pages) {
            paginationButtons.push(
                `<button type="button" role="button" disabled>
                    ...
                </button>`
            );
        }
        paginationButtons.push(
            `<button data-page="${pages}" type="button" role="button" class="${nCurrentPage === pages ? 'tabulator-page active disabled' : 'tabulator-page'}" ${pages === nCurrentPage ? 'disabled' : ''}>
                    ${pages}
                </button>`
        );
    } else {
        for (let i = 1; i <= pages; i++) {
            paginationButtons.push(
                $(`<button data-page="${i}" type="button" role="button" class="${nCurrentPage === i ? 'tabulator-page active disabled' : 'tabulator-page'}" ${i === nCurrentPage ? 'disabled' : ''}>
                        ${i}
                    </button>`)[0]
            );
        }
    }

    $paginationSlot.html(paginationButtons);
    if (pages > 0) {
        $paginator.removeClass('_hide');
    } else {
        $paginator.addClass('_hide');
    }
    
    return nCurrentPage;
}